export default __webpack_public_path__ + "static/media/Old3.ef86d899.svg";